/* Artuvate native PDP (clone of the FisioRest GemPages page): gallery, variant cards, dots. */
(function () {
  if (window.__arpInit) return;
  window.__arpInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- gallery ---------- */
  function initGallery(root) {
    var track = root.querySelector('[data-arp-track]');
    if (!track) return;
    var slides = [].slice.call(track.querySelectorAll('[data-arp-slide]'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-arp-thumb]'));
    var tlist = root.querySelector('[data-arp-tlist]');
    var prev = root.querySelector('[data-arp-prev]');
    var next = root.querySelector('[data-arp-next]');
    var current = 0;
    var isDesktop = function () { return window.matchMedia('(min-width: 768px)').matches; };

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      var t = thumbs[i];
      if (t && tlist) {
        if (isDesktop()) {
          var l = t.offsetLeft - tlist.offsetLeft;
          if (l < tlist.scrollLeft || l + t.offsetWidth > tlist.scrollLeft + tlist.clientWidth) tlist.scrollTo({ left: Math.max(0, l - 12), behavior: 'smooth' });
        } else {
          var tp = t.offsetTop - tlist.offsetTop;
          if (tp < tlist.scrollTop || tp + t.offsetHeight > tlist.scrollTop + tlist.clientHeight) tlist.scrollTo({ top: Math.max(0, tp - 8), behavior: 'smooth' });
        }
      }
      slides.forEach(function (s, k) {
        var v = s.querySelector('video');
        if (v && k !== i && !v.paused) { v.pause(); s.classList.remove('is-playing'); v.controls = false; }
      });
    }

    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      setActive(i);
    }

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) setActive(i);
      });
    }, { passive: true });

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });

    function updateArrows() {
      if (!tlist) return;
      if (isDesktop()) {
        if (prev) prev.classList.toggle('is-on', tlist.scrollLeft > 4);
        if (next) next.style.display = (tlist.scrollLeft + tlist.clientWidth >= tlist.scrollWidth - 4) ? 'none' : '';
      } else {
        if (next) next.style.display = (tlist.scrollTop + tlist.clientHeight >= tlist.scrollHeight - 4) ? 'none' : '';
        if (prev) prev.classList.remove('is-on');
      }
    }
    if (tlist) {
      tlist.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }
    if (next) next.addEventListener('click', function () {
      if (!tlist) return;
      if (isDesktop()) tlist.scrollBy({ left: 202, behavior: 'smooth' });
      else tlist.scrollBy({ top: 126, behavior: 'smooth' });
    });
    if (prev) prev.addEventListener('click', function () {
      if (tlist) tlist.scrollBy({ left: -202, behavior: 'smooth' });
    });

    root.querySelectorAll('[data-arp-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var slide = btn.closest('[data-arp-slide]');
        var v = slide && slide.querySelector('video');
        if (!v) return;
        v.muted = false;
        v.controls = true;
        slide.classList.add('is-playing');
        v.play();
      });
    });

    root.__arpGoToMedia = function (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (mediaId && String(slides[i].getAttribute('data-media-id')) === String(mediaId)) { goTo(i); return; }
      }
      goTo(0); // a variant without its own picture goes back to the first picture
    };
  }

  /* ---------- variant cards ---------- */
  function initVariants(buy) {
    var cards = [].slice.call(buy.querySelectorAll('[data-arp-card]'));
    var idInput = buy.querySelector('[data-arp-id]');
    var btn = buy.querySelector('[data-arp-atc]');
    var label = buy.querySelector('[data-arp-atc-label]');
    var stock = buy.querySelector('[data-arp-stock]');
    var stockText = buy.querySelector('[data-arp-stock-text]');
    var gal = buy.querySelector('[data-arp-gal]');
    if (!cards.length || !idInput) return;
    var inStock = stockText ? stockText.textContent : '';
    var addLabel = label ? label.textContent : 'Add to bag';
    if (cards.length > 1) {
      var inStockText = buy.getAttribute('data-stock-text');
    }
    var firstAvailable = cards.filter(function (c) { return c.getAttribute('data-available') === 'true'; })[0];
    var defaultStock = (stockText && stockText.dataset.default) || inStock;
    if (stockText && !stockText.dataset.default) stockText.dataset.default = (inStock && inStock !== 'Sold out') ? inStock : (stockText.getAttribute('data-in') || 'In stock');

    cards.forEach(function (card) {
      var input = card.querySelector('input[type=radio]');
      if (!input) return;
      input.addEventListener('change', function () {
        cards.forEach(function (c) { c.classList.toggle('is-selected', c === card); });
        var avail = card.getAttribute('data-available') === 'true';
        idInput.value = card.getAttribute('data-variant-id');
        idInput.disabled = !avail;
        if (btn) { btn.disabled = !avail; btn.setAttribute('aria-disabled', avail ? 'false' : 'true'); }
        if (label) label.textContent = avail ? addLabel : 'Sold out';
        if (stock) stock.classList.toggle('is-out', !avail);
        if (stockText) stockText.textContent = avail ? stockText.dataset.default : 'Sold out';
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', idInput.value);
          window.history.replaceState({}, '', u.toString());
        } catch (e) { /* ignore */ }
        var mid = card.getAttribute('data-media-id');
        if (gal && gal.__arpGoToMedia) gal.__arpGoToMedia(mid);
      });
    });
  }

  /* ---------- option picker (dropdown / colour buttons): drives the hidden variant cards ---------- */
  function initPicker(buy) {
    var picker = buy.querySelector('[data-arp-picker]');
    if (!picker) return;
    var sel = picker.querySelector('[data-arp-select]');
    var sws = [].slice.call(picker.querySelectorAll('[data-arp-sw]'));
    var sumPrice = picker.querySelector('[data-arp-sum-price]');
    function choose(id) {
      var card = buy.querySelector('[data-arp-card][data-variant-id="' + id + '"]');
      var input = card && card.querySelector('input[type=radio]');
      if (!input) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      var cp = card.querySelector('.arp-card__price');
      if (cp && sumPrice) sumPrice.innerHTML = cp.innerHTML;
      sws.forEach(function (b) {
        var on = b.getAttribute('data-arp-sw') === String(id);
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (sel) sel.value = String(id);
    }
    if (sel) sel.addEventListener('change', function () { choose(sel.value); });
    sws.forEach(function (b) { b.addEventListener('click', function () { choose(b.getAttribute('data-arp-sw')); }); });
  }

  /* ---------- carousels with dots (mobile) ---------- */
  function initDots(root) {
    var track = root.querySelector('[data-arp-dots-track]');
    var dotsWrap = root.querySelector('[data-arp-dots]');
    if (!track || !dotsWrap) return;
    var items = [].slice.call(track.children);
    var dots = items.map(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to ' + (i + 1));
      b.addEventListener('click', function () { track.scrollTo({ left: items[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); });
      dotsWrap.appendChild(b);
      return b;
    });
    function sync() {
      var best = 0, bd = 1e9;
      items.forEach(function (it, i) {
        var d = Math.abs((it.offsetLeft - track.offsetLeft) - track.scrollLeft);
        if (d < bd) { bd = d; best = i; }
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === best); });
    }
    track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
    sync();
  }

  /* ---------- feature cards with more than 3: slideshow on desktop (3 in view, arrows, dots); phones keep their swipe ---------- */
  function initFeatSlide(root) {
    var track = root.querySelector('.arp-feat__track');
    var dotsWrap = root.querySelector('[data-arp-feat-dots]');
    var prev = root.querySelector('[data-arp-feat-prev]');
    var next = root.querySelector('[data-arp-feat-next]');
    if (!track || !dotsWrap) return;
    var cards = [].slice.call(track.children);
    var dots = [];
    function step() { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth; }
    function stops() {
      var s = step() || 1;
      var per = Math.max(1, Math.round((track.clientWidth + 16) / s));
      return Math.max(1, cards.length - per + 1);
    }
    function sync() {
      var i = Math.round(track.scrollLeft / (step() || 1));
      i = Math.min(dots.length - 1, Math.max(0, i));
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    function build() {
      dotsWrap.innerHTML = '';
      dots = [];
      for (var i = 0; i < stops(); i++) {
        (function (i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to ' + (i + 1));
          b.addEventListener('click', function () { track.scrollTo({ left: i * step(), behavior: 'smooth' }); });
          dotsWrap.appendChild(b);
          dots.push(b);
        })(i);
      }
      sync();
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', build);
    build();
  }

  /* ---------- size guide popup next to the size dropdown ---------- */
  function initSizeGuide(buy) {
    var open = buy.querySelector('[data-arp-sg-open]');
    var dlg = buy.querySelector('[data-arp-sg]');
    if (!open || !dlg) return;
    var close = dlg.querySelector('[data-arp-sg-close]');
    open.addEventListener('click', function () { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); });
    if (close) close.addEventListener('click', function () { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg && dlg.close) dlg.close(); });
  }

  ready(function () {
    document.querySelectorAll('[data-arp-buy]').forEach(initSizeGuide);
    document.querySelectorAll('[data-arp-feat-slide]').forEach(initFeatSlide);
    document.querySelectorAll('[data-arp-gal]').forEach(initGallery);
    document.querySelectorAll('[data-arp-buy]').forEach(initVariants);
    document.querySelectorAll('[data-arp-buy]').forEach(initPicker);
    document.querySelectorAll('[data-arp-dots-root]').forEach(initDots);
  });
})();
